import React, { useState, useEffect, useRef } from "react";
import Clock from "react-clock";
import "react-clock/dist/Clock.css";

const AnalogClock = ({
  initialTime,
  checkTime,
  onClick,
  size = 180,
  renderNumbers = true,
  renderHourMarks = true,
  renderMinuteMarks = true,
  showSeconds = false,
}) => {
  const [time, setTime] = useState(() => new Date(initialTime));
  const timerRef = useRef(null);

  useEffect(() => {
    setTime(new Date(initialTime));

    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    timerRef.current = setInterval(() => {
      setTime((prevTime) => new Date(prevTime.getTime() + 1000));
    }, 1000);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [initialTime]);

  // react-clock draws hands and marks in fixed px widths tuned for its 150px
  // default; only their positions scale with `size`. Grow the widths with the
  // square root of the size, so small clocks keep readable hands and big ones
  // don't look spindly, and scale the number font with the face.
  const k = Math.sqrt(size / 150);
  const px = (w) => Math.max(1, Math.round(w * k * 10) / 10);
  const fontSize = Math.min(40, Math.max(10, size * 0.075));

  return (
    <div className="analog-clock-wrapper" onClick={onClick} style={{ fontSize }}>
      <Clock
        className="my-clock"
        value={time}
        size={size}
        renderNumbers={renderNumbers}
        renderHourMarks={renderHourMarks}
        renderMinuteMarks={renderMinuteMarks}
        hourHandWidth={px(4)}
        minuteHandWidth={px(2)}
        hourMarksWidth={px(3)}
        minuteMarksWidth={px(1)}
        secondHandLength={showSeconds ? 90 : 0}
        secondHandWidth={showSeconds ? px(3) : 0}
      />
    </div>
  );
};

export default AnalogClock;
